<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <!-- SIM, É ADMIN POIS ESTA VIEW é para ADMINS -->
              <DialogNovoSubGrupo
                                  :user="user"
                                  @closed="closedDialog"
                                  @updated="updatedCreateEdit"
                                  @created="updatedCreateEdit"
                                  :subGroup="editSubGroup"
                                  :float-right="true"
                                  :dialogStatus="dialogCreateEdit" />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                                v-model="filters.searchText"
                                label="Nome"
                                clearable
                                density="compact"
                                hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                            v-model="filters.ramo"
                            :items="ramoFilterItems"
                            item-title="title"
                            item-value="value"
                            label="Ramo"
                            clearable
                            density="compact"
                            hide-details></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()"><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                  pesquisa</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="exportSubGroups()">
                  <v-icon>mdi-file-excel-box</v-icon>
                  <span v-if="mdAndUp">Excel</span>
                </v-btn>
                <v-btn color="primary" type="submit"><v-icon class="mr-2">mdi-magnify</v-icon>Pesquisar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Grupos/Tropas
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="searchFilter"
              append-inner-icon="mdi-magnify"
              label="Filtrar resultados"
              clearable
              single-line
              hide-details
            ></v-text-field> -->
          </v-card-title>
          <v-data-table
                        :headers="headers"
                        :items="lstObjects"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.ramo="{ item }">
              <span>{{ ramoLabel(item.ramo) }}</span>
            </template>
            <template v-slot:item.chefes="{ item }">
              <span>{{ chefesLabel(item) }}</span>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{
                $moment(item.created_at).format("DD/MM/YYYY HH:mm")
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editObject(item)">
                    <v-list-item-title><v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                      Editar Grupos/Tropas</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.ramo" @click="openSetRamo(item)">
                    <v-list-item-title><v-icon color="primary" class="mr-2">mdi-flag-outline</v-icon>
                      Definir ramo</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$router.push({ name: 'SubGroupMembers', params: { sub_group_id: item.id } })">
                    <v-list-item-title><v-icon color="primary" class="mr-2">mdi-account-multiple</v-icon>
                      Ver membros</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!item.user_id" @click="deleteObject(item)">
                    <v-list-item-title><v-icon color="red" class="mr-2">mdi-delete</v-icon> Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogSetRamo" max-width="400">
      <v-card>
        <v-toolbar color="primary" title="Definir ramo">
          <v-btn color="black" @click="dialogSetRamo = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-select
                    v-model="setRamoValue"
                    :items="ramos"
                    item-title="title"
                    item-value="value"
                    label="Ramo"
                    density="compact"
                    hide-details></v-select>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" color="error" @click="dialogSetRamo = false">Cancelar</v-btn>
          <v-btn
                 color="success"
                 :loading="requestingApi"
                 :disabled="!setRamoValue || requestingApi"
                 @click="confirmSetRamo">
            <v-icon class="mr-2">mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import DialogNovoSubGrupo from "@/components/DialogNovoSubGrupo.vue";
import { useDisplay } from 'vuetify';
import api from '@/services'
import { TROPA_RAMOS } from '@/services/group'
export default {
  setup() {
    // Destructure only the keys we want to use
    const { mdAndUp } = useDisplay();

    return { mdAndUp }
  },
  components: { DialogNovoSubGrupo },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "Ramo", key: "ramo", sortable: true },
        { title: "Chefes", key: "chefes", sortable: false },
        { title: "Data de cadastro", key: "created_at", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      lstObjects: [],
      filters: {
        searchText: null,
        ramo: null,
        itemsPerPage: 1,
      },
      ramos: TROPA_RAMOS,
      ramoFilterItems: [
        { title: "Todos", value: null },
        { title: "Sem ramo", value: "sem_ramo" },
        ...TROPA_RAMOS,
      ],
      editSubGroup: {},
      dialogCreateEdit: false,
      dialogSetRamo: false,
      setRamoTarget: null,
      setRamoValue: null,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_subgroups_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.filters.ramo = null;
      vm.searchFilter = null;
    },
    ramoLabel(ramo) {
      if (!ramo) return "—";
      const found = TROPA_RAMOS.find((r) => r.value === ramo);
      return found ? found.title : ramo;
    },
    chefesLabel(item) {
      return (item?.chefes || []).map((c) => c.name).join(", ") || "—";
    },
    listPayload() {
      var vm = this;
      const payload = { ...vm.filters };
      if (!payload.ramo) {
        delete payload.ramo;
      }
      return payload;
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.subGroup
            .list(vm.listPayload(), page || 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    updatedCreateEdit(object) {
      const vm = this;

      if (object) {
        if (!vm.editSubGroup?.id) {
          vm.lstObjects.unshift(object);
        } else {
          const ix = vm.lstObjects.findIndex((x) => x.id === object.id);
          if (ix >= 0) {
            vm.lstObjects.splice(ix, 1, {
              ...vm.lstObjects[ix],
              ...object,
            });
          }
        }
        vm.editSubGroup = { ...object };
      }
    },
    deleteObject(sub_group) {
      var vm = this;
      let _confirm = confirm("Deseja realmente excluir este Grupo/Tropa?");
      if (_confirm) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.subGroup
            .delete(sub_group.id)
            .then(() => {
              let _ix_lp_from = vm.lstObjects.findIndex(
                (x) => x.id === sub_group.id
              );
              vm.lstObjects.splice(_ix_lp_from, 1);
              vm.$notify({
                type: "success",
                text: "Removido com sucesso",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    closedDialog() {
      var vm = this;

      vm.editSubGroup = {};
      vm.dialogCreateEdit = false;
    },
    editObject(object) {
      var vm = this;

      vm.editSubGroup = object;
      vm.dialogCreateEdit = true;
    },
    openSetRamo(item) {
      var vm = this;
      vm.setRamoTarget = item;
      vm.setRamoValue = null;
      vm.dialogSetRamo = true;
    },
    confirmSetRamo() {
      var vm = this;
      if (!vm.setRamoTarget?.id || !vm.setRamoValue || vm.requestingApi) {
        return;
      }
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.subGroup
          .setRamo({ id: vm.setRamoTarget.id, ramo: vm.setRamoValue })
          .then((result) => {
            const ix = vm.lstObjects.findIndex((x) => x.id === vm.setRamoTarget.id);
            if (ix >= 0) {
              vm.lstObjects.splice(ix, 1, {
                ...vm.lstObjects[ix],
                ...(result || {}),
                ramo: result?.ramo || vm.setRamoValue,
              });
            }
            vm.dialogSetRamo = false;
            vm.setRamoTarget = null;
            vm.setRamoValue = null;
            vm.$notify({
              type: "success",
              text: "Ramo definido com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    exportSubGroups() {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.excel.exportSubGroups(vm.filters)
            .then((result) => {
              // create file link inx browser's memory
              const href = URL.createObjectURL(result);

              // create "a" HTML element with href to file & click
              const link = document.createElement('a');
              link.href = href;

              link.setAttribute('download', `Grupos_Tropas_${vm.$moment(new Date()).format("YYYYMMDD-HHmmss")}.xlsx`); //or any other extension
              document.body.appendChild(link);
              link.click();

              // clean up "a" element & remove ObjectURL
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              resolve(result);
            }).catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
              reject(err);
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_subgroups_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>